export const solarColorArray = [
  "#fff292",
  "#ffeb81",
  "#ffe471",
  "#ffdc5e",
  "#ffd349",
  "#ffcc33",
  "#fbbb3b",
  "#f7aa41",
  "#f29945",
  "#ed8749",
  "#e8754c",
]
export const windColorArray = [
  "#bfd6e2",
  "#abc8d7",
  "#98bacc",
  "#87acc0",
  "#779eb3",
  "#6890a5",
  "#5a8197",
  "#4e7488",
  "#43667a",
  "#39596a",
  "#304c5b",
]
export const windOffshoreColorArray = [
  "#b8dadd",
  "#afdadd",
  "#a4dadd",
  "#9ed9dd",
  "#92d9dd",
  "#86d9dd",
  "#7ad8de",
  "#6ed8de",
  "#5cd8de",
  "#41d8df",
  "#06d8e0",
]